var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInforme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52637 7.38789C5.52637 5.51706 6.87003 4 8.52905 4H31.9975C33.6565 4 35.0002 5.51706 35.0002 7.38789V20.8167C35.0002 22.6875 33.6565 24.2046 31.9975 24.2046H8.52905C6.87225 24.2046 5.52637 22.6875 5.52637 20.8167V7.38789Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8958 9.06263H20.912C19.9248 9.06263 19.1235 9.84765 19.1235 10.8148V11.703H6.43041C4.53657 11.703 3 13.2082 3 15.0636V32.6374C3 34.4947 4.53657 36 6.43041 36H33.254C35.1499 36 36.6844 34.4947 36.6844 32.6374V10.8127C36.6844 9.84562 35.883 9.06061 34.8958 9.06061V9.06263Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1054 24.2046C29.1054 29.3183 24.9595 33.465 19.8422 33.465C14.7249 33.465 10.579 29.3183 10.579 24.2046C10.579 19.0909 14.7269 14.9442 19.8422 14.9442C24.9574 14.9442 29.1054 19.0909 29.1054 24.2046Z",
    fill: "#BBDFDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0291 23.3399H20.7038V20.017C20.7038 19.5396 20.3176 19.1534 19.8401 19.1534C19.3626 19.1534 18.9764 19.5396 18.9764 20.017V23.342H15.6532C15.1758 23.342 14.7896 23.7282 14.7896 24.2056C14.7896 24.6809 15.1779 25.0693 15.6532 25.0693H18.9785V28.3921C18.9785 28.8695 19.3648 29.2557 19.8422 29.2557C20.3197 29.2557 20.7059 28.8695 20.7059 28.3921V25.0671H24.0312C24.5087 25.0671 24.8949 24.6788 24.8949 24.2035C24.8949 23.7261 24.5087 23.3399 24.0312 23.3399H24.0291Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4211,
    cy: 18.3159,
    r: 3.02633,
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInforme);
export default __webpack_public_path__ + "static/media/Ic_Informe.5e593a7615be55b09a9bfcc338864bd0.svg";
export { ForwardRef as ReactComponent };